<template>
  <div class="cancel-flow-feedback">
    <p class="cancel-flow-feedback__subtitle">
      We carefully review user feedback to make Shortform better
    </p>
    <textarea
      v-model="feedbackText"
      class="cancel-flow-feedback__field"
      maxlength="1000"
      placeholder="Any issues, feedback, or suggestions..."
    />
    <button class="cancel-flow-feedback__support" @click="onSupport">
      Get help from Support
    </button>
  </div>

  <div class="cancel-flow-popup__footer">
    <AppButton
      :loading="canceling"
      :disabled="canceling"
      class="cancel-flow-popup__cta"
      @click="onSendFeedback"
    >
      Send feedback
    </AppButton>
    <AppButton
      :danger="true"
      :loading="canceling"
      :disabled="canceling"
      class="cancel-flow-popup__cta"
      @click="onEndMembership"
    >
      End my membership
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import type { ReasonValue } from '@/models/billing.cancelFlow'
import { Mixpanel } from '@/analytics/mixpanel'

const props = defineProps<{
  billing: BillingView
  canceling: boolean
  reason: ReasonValue | null
}>()
const emit = defineEmits<{
  (e: 'send', feedback: string): void
  (e: 'continueCancel'): void
}>()

const router = useRouter()
const feedbackText = ref('')

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'feedback', props.reason)
})

function trackButtonClick(button: string): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'feedback',
    button,
    props.reason,
  )
}

function onSupport(): void {
  trackButtonClick('support')
  router.push({ name: 'help' })
}

function onSendFeedback(): void {
  trackButtonClick('send_feedback')
  emit('send', feedbackText.value)
}

function onEndMembership(): void {
  trackButtonClick('end_membership')
  emit('continueCancel')
}
</script>
